import { __assign } from "tslib";
import { writable } from 'svelte/store';
import { HIDE_NON_TECH_INITIALLY } from '../constants';
import data from '../data';
import { filterNonTech } from '../utility';
export var cvJobItemsState = writable(__assign(__assign({}, data.cvJobItems), { items: filterNonTech(HIDE_NON_TECH_INITIALLY, data.cvJobItems.items) }));
export var cvEduItemsState = writable(__assign(__assign({}, data.cvEduItems), { items: filterNonTech(HIDE_NON_TECH_INITIALLY, data.cvEduItems.items) }));
export var skillsState = writable(__assign(__assign({}, data.skills), { items: data.skills.items.map(function (skill) { return (__assign(__assign({}, skill), { items: filterNonTech(HIDE_NON_TECH_INITIALLY, skill.items) })); }) }));
